import React from 'react';
import { Link } from 'react-router-dom';

import { MachineCard } from '@/components/MachineCard';
import { useGetMyMachines } from '@/lib/api/orval/target/machines/machines';
import { useAuthStore } from '@/stores/authStore';
import { errorMessage } from '@/lib/errors';

export function MyMachines(): React.ReactElement {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const hasChecked = useAuthStore((s) => s.hasCheckedSession);

  const { data, isLoading, error } = useGetMyMachines({
    query: { enabled: isAuthenticated },
  });

  if (hasChecked && !isAuthenticated) {
    return (
      <div className="themed-card p-6 text-center">
        <p className="mb-3">You need to be logged in to see your machines.</p>
        <Link to="/login" className="btn-primary">
          Log in
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-2xl font-semibold">My machines</h1>
      {isLoading && <p style={{ color: 'var(--text-secondary)' }}>Loading…</p>}
      {error && <p style={{ color: 'var(--danger)' }}>{errorMessage(error)}</p>}
      <div className="grid gap-4 sm:grid-cols-2">
        {data?.machines.map((machine) => (
          <MachineCard key={machine.public_id} machine={machine} />
        ))}
      </div>
      {data && data.machines.length === 0 && (
        <p style={{ color: 'var(--text-secondary)' }}>
          You don&apos;t have any machines yet — fork one to get started.
        </p>
      )}
    </div>
  );
}
